import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';
import { MENU } from '@/constants/menu';
import { formatBottomLink } from '@/utils/menuUtils';
import MenuLink from '../MenuLink';
import DesktopMenuEspot from './DesktopMenuEspot';
import styles from './DesktopMenuLayout.module.scss';
import DesktopMenuLinks from './DesktopMenuLinks';
import DesktopMenuSubmenu from './DesktopMenuSubmenu';

const DesktopMenuLayout = ({ navBarMenu, activeParentMenu, onMouseEnter, onClickMenu }) => {
	const mainAttrs = useMemo(() => {
		const active = activeParentMenu === navBarMenu._id;
		return {
			className: `${styles['desktop-menu-layout']} dropdown-menu ${active ? 'show' : ''}`,
			'aria-expanded': active,
			role: 'menu',
		};
	}, [navBarMenu, activeParentMenu]);

	const getColClassName = useCallback((section) => `col-${section.colSize} ${styles['no-col-padding']}`, []);

	const getSectionClassName = useCallback(
		(section) => `${styles['desktop-menu-layout-section']} ${styles[section.menuType.toLowerCase()]}`,
		[],
	);

	return (
		<div {...mainAttrs} onMouseEnter={onMouseEnter} data-test-id="desktop-menu-layout">
			<div className={`row ${styles['no-row-margin']}`}>
				{navBarMenu?.menuPart?.map(
					(section, i) =>
						section && (
							<React.Fragment key={i}>
								<div className={`${getColClassName(section)} ${getSectionClassName(section)}`}>
									{section.menuType === MENU.LINKS && section.menuLinks?.length > 0 && (
										<DesktopMenuLinks
											data={section.menuLinks}
											menuLevel1={navBarMenu.name}
											onClickMenu={onClickMenu}
										/>
									)}
									{section.menuType === MENU.SUBMENU && section.subMenus?.length > 0 && (
										<div className={styles['sub-menu-container']}>
											<DesktopMenuSubmenu
												data={section.subMenus}
												menuLevel1={navBarMenu.name}
												onClickMenu={onClickMenu}
											/>
											{(section.bottomTypeLink || section.bottomData) && (
												<div className={styles['sub-menu-bottom-data']}>
													{section.bottomTypeLink ? (
														<MenuLink
															isMobile={false}
															type={MENU.LINKS}
															link={formatBottomLink(section)}
														/>
													) : (
														<DesktopMenuEspot
															data={section}
															menuLevel1={navBarMenu.name}
															onClickMenu={onClickMenu}
															bottomData
														/>
													)}
												</div>
											)}
										</div>
									)}
									{section.menuType === MENU.ESPOT && (section.htmlContent || section.espotForFront) && (
										<DesktopMenuEspot data={section} menuLevel1={navBarMenu.name} onClickMenu={onClickMenu} />
									)}
								</div>
							</React.Fragment>
						),
				)}
			</div>
		</div>
	);
};

DesktopMenuLayout.propTypes = {
	navBarMenu: PropTypes.object.isRequired,
	activeParentMenu: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	onMouseEnter: PropTypes.func,
	onClickMenu: PropTypes.func.isRequired,
};

export default React.memo(DesktopMenuLayout);
